// extracted by mini-css-extract-plugin
export default {"profileWrapper":"Profile_profileWrapper__YNDNc"};